<template>
  <div class="create-edit-supplier-modal petit-nature-modal">
    <div class="header">
      <h1 class="subtitle is-4" v-if="isCreateSupplier">Novo fornecedor</h1>
      <h1 class="subtitle is-4" v-else>Editar fornecedor</h1>
      <span class="close-button" @click="$emit('close')">
        <i class="mdi mdi-window-close"></i>
      </span>
    </div>
    <form
      action=""
      class="body"
      novalidate
      @submit.prevent="validateBeforeSubmit"
    >
      <div class="columns is-multiline is-variable">
        <div class="column is-12">
          <div
            class="field"
            :class="{
              'input-error':
                !$v.supplier.name.$required && $v.supplier.name.$error
            }"
          >
            <label class="label" for="supplierName">Nome</label>
            <div class="control">
              <input
                type="text"
                class="input"
                id="supplierName"
                name="supplierName"
                v-model.trim="$v.supplier.name.$model"
              />
              <b-tooltip
                label="Campo requerido"
                type="is-danger"
                v-if="!$v.supplier.name.$required && $v.supplier.name.$error"
              >
                <span class="error-icon has-text-danger"
                  ><i class="mdi mdi-alert-circle"></i
                ></span>
              </b-tooltip>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label" for="supplierName">CNPJ</label>
            <div class="control">
              <input
                type="text"
                class="input"
                id="supplierCNPJ"
                name="supplierCNPJ"
                v-model.trim="supplier.cpfCnpj"
              />
            </div>
          </div>
        </div>
        <div class="footer column is-12 has-text-right">
          <button
            type="submit"
            class="button is-medium is-primary"
            :class="{ 'is-loading': isPendingAction }"
            :disabled="isPendingAction"
          >
            <span v-if="isCreateSupplier">Adicionar</span>
            <span v-else>Salvar</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapState, mapActions } from "vuex";
import NotificationsWrapper from "../../helpers/NotificationsWrapper";
import BTooltip from "buefy/src/components/tooltip/Tooltip";
export default {
  name: "CreateEditSupplierModal",
  components: { BTooltip },
  data: () => ({
    isCreateSupplier: true,
    isPendingAction: false,
    supplier: {}
  }),
  computed: {
    ...mapState({})
  },
  methods: {
    ...mapActions({
      createSupplier: "supplier/createSupplier",
      editSupplier: "supplier/editSupplier"
    }),
    validateBeforeSubmit() {
      this.$v.supplier.$touch();
      if (this.$v.supplier.$invalid) {
        return;
      }
      if (this.isCreateSupplier) {
        this.createSupplier(this.supplier)
          .then(() => {
            NotificationsWrapper.success("Fornecedor cadastrado com sucesso!");
            this.$emit("close");
          })
          .catch(error => {
            let errorCode = { error }.error.response.status;

            switch (errorCode) {
              default:
                NotificationsWrapper.error(
                  "Não foi possível atualizar o fornecedor. Tente novamente."
                );
                break;
            }
          })
          .finally(() => (this.isPendingAction = false));
      } else {
        this.editSupplier(this.supplier)
          .then(() => {
            NotificationsWrapper.success("Fornecedor atualizado com sucesso!");
            this.$emit("close");
          })
          .catch(error => {
            let errorCode = { error }.error.response.status;

            switch (errorCode) {
              default:
                NotificationsWrapper.error(
                  "Não foi possível atualizar o fornecedor. Tente novamente."
                );
                break;
            }
          })
          .finally(() => (this.isPendingAction = false));
      }
    }
  },
  validations: {
    supplier: {
      name: { required }
    }
  },
  props: {
    supplierParam: {}
  },
  created() {
    if (!this.supplierParam.id) {
      this.isCreateSupplier = true;
      this.supplier = { name: "", cpfCnpj: "" };
    } else {
      this.supplier = this.supplierParam;
      this.isCreateSupplier = false;
    }
  }
};
</script>

<style scoped></style>
